import {
  PRODUCT_TRANSACTION_ALL,
  PRODUCT_TRANSACTION_GET,
  PRODUCT_TRANSACTION_DEL,
  PRODUCT_TRANSACTION_PUT,
  PRODUCT_TRANSACTION_POST,
  PRODUCT_TRANSACTION_LOADING,
  PRODUCT_TRANSACTION_ERROR,
  PRODUCT_TRANSACTION_RESET,
  PRODUCT_TRANSACTION_EXCEL_SUCCESS
} from '../../actions/types';

const initialState = {
  productTransaction: null,
  isLoading: true,
  isCompleted: false,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case PRODUCT_TRANSACTION_LOADING:
      return { isLoading: true, isCompleted: false };
    case PRODUCT_TRANSACTION_RESET:
      return { isLoading: true, isCompleted: false, ...action.payload };
    case PRODUCT_TRANSACTION_ERROR:
      return { isLoading: true, isCompleted: false, ...action.payload };
    case PRODUCT_TRANSACTION_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PRODUCT_TRANSACTION_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PRODUCT_TRANSACTION_POST:
      return { isLoading: false, isCompleted: true };
    case PRODUCT_TRANSACTION_EXCEL_SUCCESS:
      return { isLoading: false, isCompleted: true };
    case PRODUCT_TRANSACTION_PUT:
      return { isLoading: false, isCompleted: true };
    case PRODUCT_TRANSACTION_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
